import "./SentryErrorBoundary.scss";

import React from "react";

const SentryErrorBoundary = () => {
  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <div className="sentry-error-boundary">
      <div className="sentry-error-content">
        <div className="sentry-error-logo">
          <img
            className="img"
            src="/static/images/logo-purple.png"
            alt="Kaboodle Logo"
          />
        </div>

        <div className="error-icon">
          <span className="material-icons">error_outline</span>
        </div>
        <div className="error-title">Something went wrong</div>
        <p>
          We&apos;re sorry, but something unexpected happened. Our team has been
          notified and is working to fix the issue.
        </p>

        <div className="flex ac-c jc-c">
          <button onClick={handleGoHome} className="button undefined">
            Go to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default SentryErrorBoundary;
